import API, { APIWithoutURLBase, APIWithoutURLBaseAndAuth } from './API';

const path = `relatorios`;

const RelatorioService = {

    // RELATÓRIO DE DEPENDENCIAS ADMINISTRATIVAS
    reportDependenciasAdministrativas: async () => await API.list(`${path}/dependencias-administrativas`),
    filtersReportDependenciasAdministrativas: async filters => await API.filters(`${path}/dependencias-administrativas`, filters),
    exportReportDependenciasAdministrativas: async filters => await API.export(`${path}/dependencias-administrativas`, filters),

    // RELATÓRIO DE MUNICÍPIOS
    reportMunicipios: async () => await API.list(`${path}/municipios`),
    filtersReportMunicipios: async filters => await API.filters(`${path}/municipios`, filters),
    exportReportMunicipios: async filters => await API.export(`${path}/municipios`, filters),

    // RELATÓRIO DE MUNICÍPIOS RESIDENCIAIS
    reportMunicipiosResidenciais: async () => await API.list(`${path}/municipios-residenciais`),
    filtersReportMunicipiosResidenciais: async filters => await API.filters(`${path}/municipios-residenciais`, filters),
    exportReportMunicipiosResidenciais: async filters => await API.export(`${path}/municipios-residenciais`, filters),

    // RELATÓRIO DE UF'S
    reportUfs: async () => await API.list(`${path}/ufs`),
    filtersReportUfs: async filters => await API.filters(`${path}/ufs`, filters),
    exportReportUfs: async filters => await API.export(`${path}/ufs`, filters),

    // RELATÓRIO DE INSCRIÇÕES POR DATA
    reportInscricoesPorData: async () => await API.list(`${path}/inscricoes/por-data`),
    filtersReportInscricoesPorData: async filters => await API.filters(`${path}/inscricoes/por-data`, filters),
    exportReportInscricoesPorData: async filters => await API.export(`${path}/inscricoes/por-data`, filters),

    // RELATÓRIO DE INSCRIÇÕES POR EDICAO
    reportInscricoesPorEdicao: async () => await API.list(`${path}/inscricoes/por-edicao`),
    filtersReportInscricoesPorEdicao: async filters => await API.filters(`${path}/inscricoes/por-edicao`, filters),
    filtersReportInscricoesPorEdicaoOtherEdition: async (edition, filters) => await APIWithoutURLBase.filters(`${process.env.REACT_APP_GATEWAY_URL}/olimpiada-professores-mirim-${edition}-services/${path}/inscricoes/por-edicao`, filters),

    // RELATÓRIO PÚBLICO DE NÚMEROS GERAIS
    reportNumbersGeneralsPublicFromEdition: async (edition) => await APIWithoutURLBaseAndAuth.list(`${process.env.REACT_APP_GATEWAY_URL}/olimpiada-professores-mirim-${edition}-services/${path}/publico/numeros-gerais`),
}

export default RelatorioService;